import axios from 'axios';
import { saveAs } from 'file-saver';
import { push } from 'connected-react-router';

import { ActionType } from '../infrastructure/actionTypes';
import {CoverDocumentType} from '../infrastructure/CoverImageTypes';
import {
    IBranding,
    ICoverImage,
    ICrop,
    IDocument,
    ILogo,
    IProduct,
    IProductLogo,
    IDisclaimer,
    IBlank,
    IFillerImage,
    ISeedCategory,
    ITechSheet,
    ISeedProductSubmit,
    DownloadDocumentType,
    IUserData,
    ISeedDivider,
    IDivider,
    ISeedIcon,
    ISeedProductClone,
    IShelfDivider,
    ITechReferenceSheet,
    IPostcardImage,
    IPosterImage,
    ITagline,
    ITechReferenceSheetType,
    ProductLine,
} from '../infrastructure/interfaces';
import { ProductType } from '../infrastructure/ProductType';
import AgronomyReferenceSheetService from '../services/AgronomyReferenceSheetService'
import BlankService from '../services/BlankService'
import BrandingService from '../services/BrandingService'
import CoverService from '../services/CoverService'
import CropImageService from '../services/CropImageService';
import DocumentService from '../services/DocumentService';
import DisclaimerService from '../services/DisclaimerService'
import FillerImageService from '../services/FillerImageService';
import PostcardImageService from '../services/PostcardImageService';
import PosterImageService from '../services/PosterImageService';
import LogoService from '../services/LogoService'
import OrderService from '../services/OrderService'
import ProductService from '../services/ProductService';
import SeedIconService from "../services/SeedIconService";
import ImageService from '../services/ImageService';
import SeedDividerService from "../services/SeedDividerService";
import TaglineService from '../services/TaglineService'
import TechSheetService from '../services/TechSheetService'
import UserService from '../services/UserService';
import {
    subscribeToDownloadPDF,
    pdfDownloadedSuccess,
    subscribeToDownloadCostReport,
    costReportDownloadedSuccess,
    subscribeToDownloadTechSheetZip,
    techSheetZipDownloadedSuccess,
    subscribeToDownloadOrderAnalysisReport,
    subscribeToDownloadProductAnalysisReport,
    orderAnalysisReportDownloadedSuccess,
    productAnalysisReportDownloadedSuccess,
} from '../services/SocketService';
import { store } from '../components/App/components/App';
import { getCountryCode } from '../config';
import {TemplateType} from "../infrastructure/TemplateType";
import { socketID } from '../services/SocketService';
import { getHomePageRoute } from '../infrastructure/HomePageRoute'
import { renderDocumentToString, getDocumentLinkAnnotations } from '../services/RenderingService';
import { createPDF, fetchPDFStyles } from '../services/PDFService';
import * as GoogleAnalyticsEvents from "../infrastructure/GoogleAnalyticsEvents";
import ShelfDividerService from "../services/ShelfDividerService";

export const startLoading = () => ({ type: ActionType.START_LOADING });
export const stopLoading = () => ({ type: ActionType.STOP_LOADING });

subscribeToDownloadPDF((err: any, cmykFileName: string, fileId: number) => {
  DocumentService.getCreatedPdf(cmykFileName)
    .then((file) => {
      let blob = new Blob([file as BlobPart], {type: 'application/pdf'});
      saveAs(blob, 'document.pdf');
      store.dispatch({
        type: ActionType.FINISH_LOADING_PDF,
        name: cmykFileName,
        id: fileId,
      });
      pdfDownloadedSuccess(cmykFileName);
      window.setTimeout(() => {
        store.dispatch({
          type: ActionType.DELETE_PDF_FROM_DOWNLOAD,
          name: cmykFileName,
          id: fileId,
        });
      }, 2000);
    })
    .catch(error => console.error(error));
});

subscribeToDownloadCostReport((err: any, fileName: string, fileId: number) => {
  OrderService.getCostReportFile(fileName)
    .then((file) => {
      let blob = new Blob([file as BlobPart], {type: 'application/csv'});
      saveAs(blob, 'report.csv');
      store.dispatch({
        type: ActionType.FINISH_LOADING_CSV,
        name: fileName,
        id: fileId,
      });
      costReportDownloadedSuccess(fileName);
      window.setTimeout(() => {
        store.dispatch({
          type: ActionType.DELETE_CSV_FROM_DOWNLOAD,
          name: fileName,
          id: fileId,
        });
      }, 2000);
    })
    .catch(error => console.error(error));
});

subscribeToDownloadOrderAnalysisReport((err: any, fileName: string, fileId: number) => {
  OrderService.getOrderAnalyticsReport(fileName)
      .then((file) => {
          let blob = new Blob([file as BlobPart], {type: 'application/csv'});
          saveAs(blob, 'report.csv');
          store.dispatch({
              type: ActionType.FINISH_LOADING_CSV,
              name: fileName,
              id: fileId,
          });
          orderAnalysisReportDownloadedSuccess(fileName);
          window.setTimeout(() => {
              store.dispatch({
                  type: ActionType.DELETE_CSV_FROM_DOWNLOAD,
                  name: fileName,
                  id: fileId,
              });
          }, 2000);
      })
      .catch(error => console.error(error));
});

subscribeToDownloadProductAnalysisReport((err: any, fileName: string, fileId: number) => {
    OrderService.getProductAnalyticsReport(fileName)
        .then((file) => {
            let blob = new Blob([file as BlobPart], {type: 'application/csv'});
            saveAs(blob, 'report.csv');
            store.dispatch({
                type: ActionType.FINISH_LOADING_CSV,
                name: fileName,
                id: fileId,
            });
            productAnalysisReportDownloadedSuccess(fileName);
            window.setTimeout(() => {
                store.dispatch({
                    type: ActionType.DELETE_CSV_FROM_DOWNLOAD,
                    name: fileName,
                    id: fileId,
                });
            }, 2000);
        })
        .catch(error => console.error(error));
});

subscribeToDownloadTechSheetZip((err: any, fileName: string, fileId: number) => {
    TechSheetService.getTechSheetsZipFile(fileName)
        .then((file) => {
            let blob = new Blob([file as BlobPart], {type: 'application/zip'});
            saveAs(blob, 'techSheets.zip');
            store.dispatch({
                type: ActionType.FINISH_LOADING_ZIP,
                name: fileName,
                id: fileId,
            });
            techSheetZipDownloadedSuccess(fileName);
            window.setTimeout(() => {
                store.dispatch({
                    type: ActionType.DELETE_ZIP_FROM_DOWNLOAD,
                    name: fileName,
                    id: fileId,
                });
            }, 2000);
        })
        .catch(error => console.error(error));
});

export const createDocument = (prodType: ProductType, userID: string) => {
  return (dispatch: any, getState: any) => {
    const { wizard } = getState();
    dispatch(getCrops());
    dispatch({
      prodType,
      pagesCount: wizard.pagesCount,
      type: ActionType.CREATE_DOCUMENT,
    });
  };
};

export const setupWizard = (prodType: ProductType) => {
  return (dispatch: any) => {
    dispatch(resetValidations());
    dispatch({
      prodType,
      type: ActionType.SETUP_WIZARD,
    });
  };
};

export const setNewProductProductType = (prodType: ProductType) => {
    return (dispatch: any) => {
        dispatch({
            prodType: prodType,
            type: ActionType.SET_NEW_PRODUCT_PRODUCT_TYPE,
        });
    };
};

export const setNewProductTemplateType = (templateType: TemplateType) => {
    return (dispatch: any) => {
        dispatch({
            templateType: templateType,
            type: ActionType.SET_NEW_PRODUCT_TEMPLATE_TYPE,
        });
    };
};

export const status = () => {
  return (dispatch: any) => {
    dispatch({
      type: ActionType.LOGGING_IN,
    });

    UserService.status()
      .then((user: IUserData) => {
        if (user.role != undefined) {
          GoogleAnalyticsEvents.configureAfterLogin(user);
          dispatch({
            type: ActionType.LOGGED_IN,
            payload: user,
          });
        } else {
          dispatch({ type: ActionType.STOP_LOADING });
          dispatch(push('/ReLogin'));
        }
      });
  };
};

export const login = (data: any) => {
  return (dispatch: any) => {
    dispatch({
      type: ActionType.LOGGING_IN,
    });
    UserService.login(data)
      .then((user: IUserData) => {
        GoogleAnalyticsEvents.configureAfterLogin(user);
        dispatch({
          type: ActionType.LOGGED_IN,
          payload: { user },
        });

        const homeRoute = (user) ? getHomePageRoute(user.role) : '/Login';
        dispatch(push(homeRoute));
      })
      .catch(error => dispatch({ type: ActionType.LOGIN_FAILED }));
  };
};

export const toggleCrop = (crop: ICrop) => {
  return {
    crop,
    type: ActionType.TOGGLE_CROP,
  };
};

export const toggleBranding = (branding: IBranding) => {
  return {
    branding,
    type: ActionType.TOGGLE_BRANDING,
  };
};

export const moveCrop = (dragIndex: number, hoverIndex: number) => {
  return {
    dragIndex,
    hoverIndex,
    type: ActionType.MOVE_CROP,
  };
};

export const toggleLogo = (logo: ILogo) => {
  return {
    logo,
    type: ActionType.TOGGLE_LOGO,
  };
};

export const changeCropImage = (crop: ICrop, image: string) => {
  return {
    crop,
    image,
    type: ActionType.CHANGE_CROP_IMAGE,
  };
};

export const changeCompanyInfo = (text: string, field: string) => {
  return {
    text,
    field,
    type: ActionType.CHANGE_COMPANY_INFO,
  };
};

export const changeBranding = (branding: IBranding) => {
  return {
    branding,
    type: ActionType.CHANGE_BRANDING,
  };
};
export const changePostcardImageFront = (postcardImageFront: IPostcardImage) => {
  return {
    postcardImageFront,
    type: ActionType.CHANGE_POSTCARD_IMAGE_FRONT,
  };
};
export const changePostcardImageBack = (postcardImageBack: IPostcardImage) => {
  return {
    postcardImageBack,
    type: ActionType.CHANGE_POSTCARD_IMAGE_BACK,
  };
};
export const changePosterImageBackground = (posterImageBackground: IPosterImage) => {
  return {
    posterImageBackground,
    type: ActionType.CHANGE_POSTER_IMAGE_BACKGROUND,
  };
};
export const changeDocumentTitle = (title: string) => {
  return {
    title,
    type: ActionType.CHANGE_DOCUMENT_TITLE,
  };
};

export const changeCoverImage = (coverImage: ICoverImage) => {
  return {
    coverImage,
    type: ActionType.CHANGE_COVER_IMAGE,
  };
};

export const changeAdditionalInfo = (text: string | boolean, field: string) => {
  return {
    text,
    field,
    type: ActionType.CHANGE_ADDITIONAL_INFO,
  };
};

export const saveDocument = (document: IDocument, userID: string, redirect?: string) => {
  return (dispatch: any, getState: any) => {
    dispatch({
      type: ActionType.SAVE_DOCUMENT,
      document,
    });
    DocumentService
      .saveDocument(document, userID)
      .then((documentB) => {
        dispatch({
          type: ActionType.SAVE_DOCUMENT_DONE,
          document,
        });
        if (redirect) {
          dispatch(push(redirect));
        }
      })
      .catch(error => console.error(error));
  };
};
export const updateDocument = (pagesCount: number, userID: string) => {
  return (dispatch: any, getState: any) => {
    dispatch({
      pagesCount,
      type: ActionType.CHANGE_DOCUMENT_PAGES_COUNT,
    });
    const updatedDocument = getState().document;
    dispatch(saveDocument(updatedDocument, userID));
  };
};
export const createSaveDocument = (document: IDocument, userID: string) => {
  return (dispatch: any, getState: any) => {
    const { pagesCount } = getState().wizard;
    dispatch({
      type: ActionType.CHANGE_DOCUMENT_PAGES_COUNT,
      pagesCount,
    });
    dispatch({ type: ActionType.START_LOADING });
    dispatch(getProducts(document.type));
    DocumentService
      .createDocument(document, userID)
      .then((documentB) => {
        dispatch({
          type: ActionType.SAVE_DOCUMENT_DONE,
          document: documentB,
        });

        dispatch({ type: ActionType.STOP_LOADING });
      })
      .catch(error => console.error(error));
  };
};
export const openDocumentById = (id: string, redirect?: string) => {
  return (dispatch: any, getState: any) => {
    dispatch({ type: ActionType.START_LOADING });
    axios
      .get(`/documents/${id}`)
      .then((res) => {
        const document = JSON.parse(res.data.document.replace(/\n/g, "\\n")
        .replace(/\r/g, "\\r")
        .replace(/\t/g, "\\t")
        .replace(/\f/g, "\\f"));
        const { wizard } = getState();
        dispatch({
          type: ActionType.OPEN_DOCUMENT_DONE,
          document,
          wizard,
        });
        dispatch(getProducts(document.type));
        dispatch({ type: ActionType.STOP_LOADING });

        if (redirect) {
          dispatch(push(redirect));
        }
      })
      .catch(error => console.error(error));
  };
};

export const skipStep = (step: any) => {
  return {
    step,
    type: ActionType.SKIP_STEP,
  };
};

export const toggleCropPageView = (cropPageView: any) => {
  return {
    cropPageView,
    type: ActionType.TOGGLE_CROP_PAGE_VIEW,
  };
};

export const getPagesView = (products: any) => {
  return {
    products,
    type: ActionType.GET_PAGES_VIEW,
  };
};

export const updateBrandings = (brandings: any) => {
  return {
    brandings,
    type: ActionType.UPDATE_BRANDINGS,
  };
};

export const getCrops = () => {
  return (dispatch: any) => {
    axios.get('/crops')
      .then((res) => {
        dispatch({
          type: ActionType.GET_CROPS,
          crops: res.data,
        });
      });
  };
}

export const createCrop = (photoName: string, formData: FormData) => {
  formData.set('cropCoverPhotoName', photoName);
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    CropImageService
      .createCropImage(formData)
      .then((newCrop: ICrop) => {
        dispatch({ type: ActionType.CREATE_CROP_DONE, newCrop})
        dispatch({ type: ActionType.STOP_LOADING});
        GoogleAnalyticsEvents.createSmallCoverImage(newCrop)
      })
      .catch(error => console.error(error));
  }
}

export const deleteCrop = (crop: ICrop) => {
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    CropImageService
        .deleteCropImage(crop.id)
        .then(() => {
          dispatch({ type: ActionType.DELETE_CROP_DONE, cropID: crop.id });
          dispatch({ type: ActionType.STOP_LOADING });
          GoogleAnalyticsEvents.deleteSmallCoverImage(crop);
        })
        .catch(error => console.error(error));
  }

}

export const getBrandings = () => {
  return (dispatch: any) => {
    axios
      .get('/brandings')
      .then((res) => {
        dispatch({
          type: ActionType.GET_BRANDINGS,
          brandings: res.data,
        });
      })
      .catch(e => console.error(e));
  };
};

export const getCoverImages = () => {
  return (dispatch: any) => {
    axios
      .get('/coverImages')
      .then((res) => {
        dispatch({
          type: ActionType.GET_COVER_IMAGES_DONE,
          coverImages: res.data,
        });
      })
      .catch(e => console.error(e));
  };
};

export const getLogos = () => {
  return (dispatch: any) => {
    axios
      .get('/logos?archived=false')
      .then(res =>
        dispatch({
          type: ActionType.GET_LOGOS,
          logos: res.data,
        }))
      .catch(e => console.error(e));
  };
};

export const archiveProductLogo = (logo: IProductLogo) => {

  return (dispatch: any, getState: any) => {
    dispatch({ type: ActionType.START_LOADING });
    ImageService
        .archiveProductLogo(logo)
        .then(() => {
          dispatch({ type: ActionType.ARCHIVE_PRODUCT_LOGO_DONE, logo: logo });
          dispatch({ type: ActionType.STOP_LOADING });
          GoogleAnalyticsEvents.archiveProductLogo(logo);
        })
        .catch(error => console.error(error));
  };
};

export const archivePostcardImage = (postcardImage: IPostcardImage) => {

  return (dispatch: any, getState: any) => {
    dispatch({ type: ActionType.START_LOADING });
    ImageService
        .archivePostcardImage(postcardImage)
        .then(() => {
          dispatch({ type: ActionType.ARCHIVE_POSTCARD_IMAGE_DONE, postcardImage: postcardImage });
          dispatch({ type: ActionType.STOP_LOADING });
        })
        .catch(error => console.error(error));
  };
};

export const archivePosterImage = (posterImage: IPosterImage) => {
  return (dispatch: any, getState: any) => {
    dispatch({ type: ActionType.START_LOADING });
    ImageService
        .archivePosterImage(posterImage)
        .then(() => {
          dispatch({ type: ActionType.ARCHIVE_POSTER_IMAGE_DONE, posterImage: posterImage });
          dispatch({ type: ActionType.STOP_LOADING });
        })
        .catch(error => console.error(error));
  };
}

export const getPosterImages = () => {
  return (dispatch: any) => {
    axios
      .get('/poster_images')
      .then((res) => {
        dispatch({
          type: ActionType.GET_POSTER_IMAGES_DONE,
          posterImages: res.data,
        });
      })
      .catch(e => console.error(e));
  };
};

export const getDisclaimers = () => {
  return (dispatch: any) => {
    axios
      .get('/disclaimers')
      .then(res => {
        dispatch({
          type: ActionType.GET_DISCLAIMERS,
          disclaimers: res.data,
        })})
      .catch(e => console.error(e));
  };
};

export const getProducts = (documentType: any) => {
  return (dispatch: any) => {
    axios
      .get(`/productsTree?documentType=${documentType}`)
      .then((res) => {
        dispatch({
          type: ActionType.GET_PRODUCT_CATEGORIES_DONE,
          productCategories: res.data,
        });
      })
      .catch(e => console.error(e));
  };
};
export const getBlanks = () => {
  return (dispatch: any) => {
    axios
      .get('/blank')
      .then((res) => {
        dispatch({
          type: ActionType.GET_BLANKS_DONE,
          blanks: res.data,
        });
      })
      .catch(e => console.error(e));
  };
};
export const getPublishedBlanks = () => {
  return (dispatch: any) => {
    axios
      .get('/blank?published=true')
      .then((res) => {
        dispatch({
          type: ActionType.GET_PUBLISHED_BLANKS_DONE,
          blanksPublished: res.data,
        });
      })
      .catch(e => console.error(e));
    };
};
export const getSeedCategories = () => {
  return (dispatch: any) => {
    axios
      .get('/seed/categories/')
      .then((res) => {
        dispatch({
          type: ActionType.GET_SEED_CATEGORIES_DONE,
          seedCategories: res.data,
        });
        res.data.forEach((category: ISeedCategory) => {
          getSeedAttributeList(category.id)(dispatch);
        });
      })
      .catch(e => console.error(e));
  };
};

export const getSeeds = () => {
  return (dispatch: any) => {
    axios
      .get('/seed/')
      .then((res) => {
        dispatch({
          type: ActionType.GET_SEEDS_DONE,
          seeds: res.data,
        });
      })
      .catch(e => console.error(e));
  }
};

export const getSeedIcons = () => {
  return (dispatch: any) => {
    axios
      .get('/seedIcon')
      .then((res) => {
        dispatch({
          type: ActionType.GET_SEED_ICONS_DONE,
          seedIcons: res.data,
        });
      })
      .catch(e => console.error(e));
  };
};
export const createSeedIcon = (iconName: string, category: ISeedCategory, formData: FormData) => {
    return (dispatch: any) => {
        dispatch({ type: ActionType.START_LOADING });
        SeedIconService
            .createSeedIcon(iconName, category, formData)
            .then((newSeedIcon: ISeedIcon) => {
                dispatch({ type: ActionType.CREATE_SEED_ICON_DONE, newSeedIcon})
                dispatch({ type: ActionType.STOP_LOADING});
                GoogleAnalyticsEvents.createSeedIcon(newSeedIcon);
            })
            .catch(error => console.error(error));
    }
};
export const toggleSeedIconPublish = (seedIcon: ISeedIcon) => {
    const toggledSeedIcon = { ...seedIcon, published: !seedIcon.published };
    return (dispatch: any) => {
        dispatch({ type: ActionType.START_LOADING });
        SeedIconService
            .toggleSeedIconPublish(toggledSeedIcon)
            .then(() => {
                dispatch({ type: ActionType.TOGGLE_SEED_ICON_PUBLISH_DONE, toggledSeedIcon });
                dispatch({ type: ActionType.STOP_LOADING });
                if (toggledSeedIcon.published) {
                    GoogleAnalyticsEvents.publishSeedIcon(toggledSeedIcon);
                } else {
                    GoogleAnalyticsEvents.unpublishSeedIcon(toggledSeedIcon);
                }
            })
            .catch(error => {
                dispatch({ type: ActionType.STOP_LOADING });
                console.error(error);
            });
    }
};
export const editSeedIcon = (seedIcon: ISeedIcon, formData?: FormData) => {
    return (dispatch: any) => {
        dispatch({ type: ActionType.START_LOADING });
        SeedIconService
            .editSeedIcon(seedIcon, formData)
            .then((updatedSeedIcon: ISeedIcon) => {
                dispatch({ type: ActionType.EDIT_SEED_ICON_DONE, updatedSeedIcon });
                dispatch({ type: ActionType.STOP_LOADING });
                GoogleAnalyticsEvents.editSeedIcon(updatedSeedIcon);
            })
            .catch(error => {
                dispatch({ type: ActionType.STOP_LOADING });
                console.error(error);
            });
    }
};
export const deleteSeedIcon = (seedIcon: ISeedIcon) => {
    return (dispatch: any) => {
        dispatch({ type: ActionType.START_LOADING });
        SeedIconService
            .deleteSeedIcon(seedIcon)
            .then(() => {
                dispatch({ type: ActionType.DELETE_SEED_ICON_DONE, iconId: seedIcon.id });
                dispatch({ type: ActionType.STOP_LOADING });
                GoogleAnalyticsEvents.deleteSeedIcon(seedIcon);
            })
            .catch(error => {
                dispatch({ type: ActionType.STOP_LOADING });
                console.error(error);
            });
    }
};

export const getPostcardImages = () => {
    return (dispatch: any) => {
        axios
            .get('/postcard_images')
            .then((res) => {
                dispatch({
                    type: ActionType.GET_POSTCARD_IMAGE_DONE,
                    postcardImages: res.data,
                })
            })
            .catch(e => console.error(e));
    }
};

export const createPostcardImage = (postcardImageName: string, postcardSide: string, formData: FormData) => {
    formData.set('postcardImageName', postcardImageName);
    formData.set('postcardSide', postcardSide);
    return (dispatch: any, getState: any) => {
        dispatch({ type: ActionType.START_LOADING });
        PostcardImageService
            .createPostcardImage(formData)
            .then((newPostcardImage: IPostcardImage) => {
                dispatch({ type: ActionType.CREATE_POSTCARD_IMAGE_DONE, newPostcardImage: newPostcardImage});
                dispatch({ type: ActionType.STOP_LOADING});
            })
            .catch(error => console.error(error));
    };
};

export const createPosterImage = (posterImageName: string, formData: FormData) => {
    formData.set('posterImageName', posterImageName);
    return(dispatch: any, getState: any) => {
        dispatch({ type: ActionType.START_LOADING });
        PosterImageService
            .createPosterImage(formData)
            .then((newPosterImage: IPosterImage) => {
              dispatch({ type: ActionType.CREATE_POSTER_IMAGE_DONE, newPosterImage: newPosterImage });
              dispatch({ type: ActionType.STOP_LOADING });
            })
            .catch(error => console.error(error));
    };
};

export const getFillerImages = () => {
    return (dispatch: any) => {
        axios
            .get('/fillerImage')
            .then((res) => {
                dispatch({
                    type: ActionType.GET_FILLER_IMAGE_DONE,
                    fillerImages: res.data,
                });
            })
            .catch(e => console.error(e));
    };
};
export const createFillerImage = (iconName: string, formData: FormData) => {
    return (dispatch: any) => {
        dispatch({ type: ActionType.START_LOADING });
        FillerImageService
            .createFillerImage(iconName, formData)
            .then((newFillerImage: IFillerImage) => {
                dispatch({ type: ActionType.CREATE_FILLER_IMAGE_DONE, newFillerImage})
                dispatch({ type: ActionType.STOP_LOADING});
                GoogleAnalyticsEvents.createFillerImage(newFillerImage);
            })
            .catch(error => console.error(error));
    }
};
export const editFillerImage = (fillerImage: IFillerImage, formData?: FormData) => {
    return (dispatch: any) => {
        dispatch({ type: ActionType.START_LOADING });
        FillerImageService
            .editFillerImage(fillerImage, formData)
            .then((updatedFillerImage: IFillerImage) => {
                dispatch({ type: ActionType.EDIT_FILLER_IMAGE_DONE, updatedFillerImage });
                dispatch({ type: ActionType.STOP_LOADING });
                GoogleAnalyticsEvents.editFillerImage(updatedFillerImage);
            })
            .catch(error => {
                dispatch({ type: ActionType.STOP_LOADING });
                console.error(error);
            });
    }
};
export const deleteFillerImage = (fillerImage: IFillerImage) => {
    return (dispatch: any) => {
        dispatch({ type: ActionType.START_LOADING });
        FillerImageService
            .deleteFillerImage(fillerImage)
            .then(() => {
                dispatch({ type: ActionType.DELETE_FILLER_IMAGE_DONE, fillerImageId: fillerImage.id });
                dispatch({ type: ActionType.STOP_LOADING });
                GoogleAnalyticsEvents.deleteFillerImage(fillerImage);
            })
            .catch(error => {
                dispatch({ type: ActionType.STOP_LOADING });
                console.error(error);
            });
    }
};

export const getAgronomyReferenceSheets = () => {
  return (dispatch: any) => {
    axios
      .get('/agronomy_reference')
      .then((res) => {
        dispatch({
          type: ActionType.GET_AGRONOMY_REFERENCE_SHEETS_DONE,
          agronomyReferenceSheets: res.data,
        });
      })
      .catch(e => console.error(e));
  };
};
export const getPublishedAgronomyReferenceSheets = () => {
  return (dispatch: any) => {
    axios
      .get('/agronomy_reference?published=true')
      .then((res) => {
        dispatch({
          type: ActionType.GET_PUBLISHED_AGRONOMY_REFERENCE_SHEETS_DONE,
          agronomyReferenceSheetsPublished: res.data,
        });
      })
      .catch(e => console.error(e));
  };
};
export const createAgronomyReferenceSheet = (sheetName: string, agronomyReferenceSheetType: ITechReferenceSheetType, formData: FormData) => {

  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    AgronomyReferenceSheetService
    .createAgronomyReferenceSheet(sheetName, agronomyReferenceSheetType, formData)
    .then((newAgronomyReferenceSheet: ITechReferenceSheet) => {
      dispatch({ type: ActionType.CREATE_AGRONOMY_REFERENCE_SHEET_DONE, newAgronomyReferenceSheet})
      dispatch({ type: ActionType.STOP_LOADING});
      GoogleAnalyticsEvents.createAgronomyReferenceSheet(newAgronomyReferenceSheet);
    })
    .catch(error => console.error(error));
  }
}
export const editAgronomyReferenceSheet = (sheetName: string, agronomyReferenceSheetType: ITechReferenceSheetType, formData: FormData, sheetToEdit: ITechReferenceSheet) => {

  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    AgronomyReferenceSheetService
    .editAgronomyReferenceSheet(sheetName, agronomyReferenceSheetType, formData, sheetToEdit)
    .then((updatedAgronomyReferenceSheet: ITechReferenceSheet) => {
      dispatch({ type: ActionType.STOP_LOADING});
      dispatch({ type: ActionType.EDIT_AGRONOMY_REFERENCE_SHEET_DONE, updatedAgronomyReferenceSheet})
      GoogleAnalyticsEvents.editAgronomyReferenceSheet(updatedAgronomyReferenceSheet);
    })
    .catch(error => console.error(error));
  }
}
export const toggleAgronomyReferenceSheetPublish = (agronomyReferenceSheet: ITechReferenceSheet) => {
  const updatedAgronomyReferenceSheet = { ...agronomyReferenceSheet, published: !agronomyReferenceSheet.published };
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    AgronomyReferenceSheetService
      .toggleAgronomyReferenceSheetPublish(updatedAgronomyReferenceSheet)
        .then(() => {
          dispatch({ type: ActionType.EDIT_AGRONOMY_REFERENCE_SHEET_DONE, updatedAgronomyReferenceSheet });
          dispatch({ type: ActionType.STOP_LOADING });
          if (updatedAgronomyReferenceSheet.published) {
              GoogleAnalyticsEvents.publishAgronomyReferenceSheet(updatedAgronomyReferenceSheet)
          } else {
              GoogleAnalyticsEvents.unpublishAgronomyReferenceSheet(updatedAgronomyReferenceSheet);
          }
        })
        .catch(error => {
          dispatch({ type: ActionType.STOP_LOADING });
          console.error(error);
        });
  }
};


export const updateBlank = (blank: IBlank, formData?: FormData) => {
  const updatedBlank = { ...blank, title: blank.title, src: blank.src };
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    BlankService
      .updateBlank(updatedBlank, formData)
      .then((updatedBlank: IBlank) => {
        dispatch({ type: ActionType.UPDATE_BLANK_DONE, updatedBlank })
        dispatch({ type: ActionType.STOP_LOADING});
          GoogleAnalyticsEvents.catalogUpdateFullscreenImage(updatedBlank);
      })
    .catch(error => console.error(error));
  }
}

export const createBlank = (blankName: string, blankURL: string, formData: FormData) => {
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    BlankService
      .createBlank(blankName, blankURL, formData)
      .then((newBlank: IBlank) => {
        dispatch({ type: ActionType.CREATE_BLANK_DONE, newBlank})
        dispatch({ type: ActionType.STOP_LOADING});
        GoogleAnalyticsEvents.catalogCreateFullscreenImage(newBlank);
      })
    .catch(error => console.error(error));
  }
}

export const toggleBlankPublish = (blank: IBlank) => {
  const toggledBlank = { ...blank, published: !blank.published };
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    BlankService
      .toggleBlankPublish(toggledBlank)
        .then(() => {
          dispatch({ type: ActionType.TOGGLE_BLANK_PUBLISH_DONE, toggledBlank });
          dispatch({ type: ActionType.STOP_LOADING });
          if (toggledBlank.published) {
              GoogleAnalyticsEvents.publishCatalogCreateFullscreenImage(toggledBlank);
          } else {
              GoogleAnalyticsEvents.unpublishCatalogCreateFullscreenImage(toggledBlank);
          }
        })
        .catch(error => {
          dispatch({ type: ActionType.STOP_LOADING });
          console.error(error);
        });
  }
};
export const getTechSheets = () => {
  return (dispatch: any) => {
    axios
      .get('/seedTechSheet')
      .then((res) => {
        dispatch({
          type: ActionType.GET_TECH_SHEETS_DONE,
          agronomyReferenceSheets: res.data,
        });
      })
      .catch(e => console.error(e));
  };
};
export const getPublishedTechSheets = () => {
  return (dispatch: any) => {
    axios
      .get('/seedTechSheet?published=true')
      .then((res) => {
        dispatch({
          type: ActionType.GET_PUBLISHED_TECH_SHEETS_DONE,
          techSheetsPublished: res.data,
        });
      })
      .catch(e => console.error(e));
  };
};
export const createTechSheets = (sheetName: string[], seedCategory: ISeedCategory, formData: FormData[]) => {

  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });

    Promise.all(sheetName.map(async (name: string, index: number) => {
      TechSheetService
      .createTechSheet(name, seedCategory, formData[index])
      .then((newTechSheet: ITechSheet) => {
        dispatch({ type: ActionType.CREATE_TECH_SHEET_DONE, newTechSheet})
        
        GoogleAnalyticsEvents.createTechSheet(newTechSheet);
      })
      .catch(error => console.error(error));
    })).then (dispatch({ type: ActionType.STOP_LOADING}))
    
  }
}
export const toggleTechSheetPublish = (techSheet: ITechSheet) => {
  const toggledTechSheet = { ...techSheet, published: !techSheet.published };
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    TechSheetService
      .toggleTechSheetPublish(toggledTechSheet)
        .then(() => {
          dispatch({ type: ActionType.TOGGLE_TECH_SHEET_PUBLISH_DONE, toggledTechSheet });
          dispatch({ type: ActionType.STOP_LOADING });
          if (toggledTechSheet.published) {
              GoogleAnalyticsEvents.publishTechSheet(toggledTechSheet);
          } else {
              GoogleAnalyticsEvents.unpublishTechSheet(toggledTechSheet);
          }
        })
        .catch(error => {
          dispatch({ type: ActionType.STOP_LOADING });
          console.error(error);
        });
  }
};
export const getSeedDividers = () => {
    return (dispatch: any) => {
        axios
            .get('/seedseparator')
            .then((res) => {
                dispatch({
                    type: ActionType.GET_SEED_DIVIDERS_DONE,
                    seedDividers: res.data,
                });
            })
            .catch(e => console.error(e));
    };
};

export const getShelfDividers = () => {
    return (dispatch: any) => {
        axios
            .get('/shelfseparator')
            .then((res) => {
                dispatch({
                    type: ActionType.GET_SHELF_DIVIDERS_DONE,
                    dividers: res.data,
                });
            })
            .catch(e => console.error(e));
    }
};

export const editSeedDivider = (divider: ISeedDivider, formData: FormData) => {

    return (dispatch: any) => {
        dispatch({ type: ActionType.START_LOADING });
        SeedDividerService
            .editSeedDivider(divider, formData)
            .then((updatedSeedDivider: ISeedDivider) => {
                dispatch({ type: ActionType.UPDATE_SEED_DIVIDER_DONE, updatedSeedDivider})
                dispatch({ type: ActionType.STOP_LOADING});
            })
            .catch(error => console.error(error));
    }
}

export const editShelfDivider = (divider: IShelfDivider, formData: FormData) => {

    return (dispatch: any) => {
        dispatch({ type:ActionType.START_LOADING });
        ShelfDividerService
            .editShelfDivider(divider, formData)
            .then((updatedShelfDivider: IShelfDivider) => {
                dispatch({ type: ActionType.UPDATE_SHELF_DIVIDERS_DONE, updatedShelfDivider})
                dispatch({ type: ActionType.STOP_LOADING})
            })
            .catch(error => console.error(error))
    }
}

export const getSeedAttributeList = (categoryId: string|number) => {
  return (dispatch: any) => {
    axios
      .get(`/seed/categories/${categoryId}/attributes`)
      .then((res) => {
        dispatch({
          type: ActionType.GET_SEED_CATEGORY_ATTRIBUTES_DONE,
          categoryId,
          seedAttributes: res.data,
        });
      })
      .catch(e => console.error(e));
  };
};
export const saveSeedProduct = (seed: ISeedProductSubmit, isTogglingPublish: Boolean) => {

  const isNewSeed = !seed.id;
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    ProductService
          .updateSeedProduct(seed)
          .then(() => {
              dispatch({ type: ActionType.STOP_LOADING });
          })
          .then(() => {

              sendSeedAnalyticsEvent(seed, isNewSeed, isTogglingPublish);
              dispatch(getSeeds());
          })
      .catch(error => console.error(error));
  };
};
export const cloneSeedProduct = (seed: ISeedProductClone) => {

    return (dispatch: any) => {
        dispatch({ type: ActionType.START_LOADING });
        ProductService
            .cloneSeedProduct(seed)
            .then(() => {
                dispatch({ type: ActionType.STOP_LOADING });
            })
            .then(() => {
                GoogleAnalyticsEvents.cloneSeed(seed);
                dispatch(getSeeds());
            })
            .catch(error => console.error(error));
    };
};
const sendSeedAnalyticsEvent = (seed: ISeedProductSubmit, isNewSeed: Boolean, sendSeedPublishToggleAnalytics: Boolean) => {
    if (isNewSeed) {
        GoogleAnalyticsEvents.createNewSeed(seed);
    } else {
        GoogleAnalyticsEvents.editSeed(seed);
        if (sendSeedPublishToggleAnalytics) {
            if (seed.published) {
                GoogleAnalyticsEvents.publishSeed(seed);
            } else {
                GoogleAnalyticsEvents.unpublishSeed(seed);
            }
        }
    }
};
export const getCropDividers = () => {
  return (dispatch: any) => {
    axios
      .get('/crop_dividers')
      .then((res) => {
        dispatch({
          type: ActionType.GET_CROP_DIVIDERS_DONE,
          cropDividers: res.data,
        });
      })
      .catch(e => console.error(e));
  };
};
export const dragNDropProduct = (data: any) => {
  return (dispatch: any, getState: any) => {
    const { document } = getState();
    dispatch({
      type: ActionType.DRAG_N_DROP_PRODUCT,
      data: {
        ...data,
        spreads: document.spreads,
      },
    });
  };
};

export const removeProduct = (data: any) => {
  return (dispatch: any, getState: any) => {
    const { document } = getState();
    dispatch({
      type: ActionType.REMOVE_PRODUCT,
      data: {
        ...data,
        spreads: document.spreads,
      },
    });
  };
};

export const saveProduct = (oldName: string,
                            product: IProduct,
                            imagesFormData?: FormData,
                            logoFormData?: FormData) => {
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    const isNewProduct = (product.id <= 0);
    ProductService
          .updateProduct(oldName, product)
          .then((updatedProduct: IProduct) => {

            if(imagesFormData) {
                //Add images
                ImageService
                .saveProductImages(updatedProduct, imagesFormData)
                .then((imageResult:any) => {
                  updatedProduct.imageArea = imageResult.file;

                    if(logoFormData) {

                      logoFormData.set('productId', updatedProduct.id.toString());

                      ImageService
                      .uploadProductLogo(logoFormData)
                      .then((logoResponse: any) => {
                        dispatch({ type: ActionType.STOP_LOADING });

                        let logoData: IProductLogo = {
                          id: (logoResponse.id as string)!,
                          src: (logoResponse.file as string)!,
                          archived: false,
                        };
                        GoogleAnalyticsEvents.createProductLogo(logoData);

                        updatedProduct.logo = logoData.src;
                        dispatch({ type: ActionType.UPDATE_PRODUCT_LOGO_DONE, logoData});
                        dispatch({ type: ActionType.SAVE_PRODUCT_DONE, updatedProduct });
                        sendProductAnalyticsEvent(updatedProduct, isNewProduct);
                      });
                    } else {
                      dispatch({ type: ActionType.STOP_LOADING });
                      dispatch({ type: ActionType.SAVE_PRODUCT_DONE, updatedProduct });
                      sendProductAnalyticsEvent(updatedProduct, isNewProduct);
                    }
                });
            } else if(logoFormData) {

              logoFormData.set('productId', updatedProduct.id.toString());
              ImageService
              .uploadProductLogo(logoFormData)
              .then((logoResponse: any) => {
                dispatch({ type: ActionType.STOP_LOADING });

                let logoData: IProductLogo = {
                  id: (logoResponse.id as string)!,
                  src: (logoResponse.file as string)!,
                  archived: false,
                };
               GoogleAnalyticsEvents.createProductLogo(logoData);

                updatedProduct.logo = logoData.src;
                dispatch({ type: ActionType.UPDATE_PRODUCT_LOGO_DONE, logoData});
                dispatch({ type: ActionType.SAVE_PRODUCT_DONE, updatedProduct });
                sendProductAnalyticsEvent(updatedProduct, isNewProduct);
              });

            } else {
              dispatch({ type: ActionType.STOP_LOADING });
              dispatch({ type: ActionType.SAVE_PRODUCT_DONE, updatedProduct });
              sendProductAnalyticsEvent(updatedProduct, isNewProduct);
            }
          })
      .catch(error => console.error(error));
  };
};

const sendProductAnalyticsEvent = (product: IProduct, isNewProduct: Boolean) => {
    if (isNewProduct) {
        GoogleAnalyticsEvents.createNewProduct(product);
    } else {
        GoogleAnalyticsEvents.editProduct(product);
    }
};

export const getDocumentList = (userID: string) => {
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    DocumentService
      .getDocumentList(userID)
      .then((documentList) => {
        dispatch({ type: ActionType.STOP_LOADING });
        dispatch({ type: ActionType.GET_DOCUMENT_LIST_DONE, documentList });
      })
      .catch(error => console.error(error));

  };
};

export const cloneDocument = (document: IDocument, name: string, userID: string) => {
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    DocumentService
      .cloneDocument(document, name, userID)
      .then((newDocument : IDocument) => {
        dispatch({ type: ActionType.STOP_LOADING });
        dispatch({type: ActionType.CLONE_DOCUMENT, newDocument});
  });
  }
}

export const getAllProducts = () => {
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    ProductService
        .getAllProducts()
        .then((products) => {

          dispatch({ type: ActionType.STOP_LOADING });
          dispatch({ type: ActionType.GET_PRODUCTS_DONE, products });
        })
        .catch(error => console.error(error));
  }
};

export const deleteProduct = (product: IProduct) => {
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    ProductService
        .deleteProduct(product.id, product.type)
        .then(() => {
          GoogleAnalyticsEvents.deleteProduct(product);
          const deleteData = {"id":product.id, "type": product.type}
          dispatch({ type: ActionType.DELETE_PRODUCT_DONE, deleteData });
          dispatch({ type: ActionType.STOP_LOADING });
        })
        .catch(error => console.error(error));
  }
};

export const toggleProductPublish = (product: IProduct, published: boolean) => {

  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    ProductService
        .toggleProductPublish(product.id, product.type, published)
        .then(() => {
          if (published) {
              GoogleAnalyticsEvents.publishProduct(product);
          } else {
              GoogleAnalyticsEvents.unpublishProduct(product);
          }
          const publishData = {"id":product.id, "type": product.type, "published": published}
          dispatch({ type: ActionType.TOGGLE_PRODUCT_PUBLISH_DONE, publishData });
          dispatch({ type: ActionType.STOP_LOADING });
        })
        .catch(error => console.error(error));
  }
};

export const updateProduct = (oldName: string, product: IProduct) => {

  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    ProductService
        .updateProduct(oldName, product)
        .then(() => {
          const updateData = {"product": product}
          dispatch({ type: ActionType.PRODUCT_UPDATE_DONE, updateData });
          dispatch({ type: ActionType.STOP_LOADING });
        })
        .catch(error => console.error(error));
  }
};

export const getStatesList = () => {
  const country = getCountryCode();
  return (dispatch: any) => {
    axios
      .get('/states?country=' + country)
      .then((res) => {
        dispatch({
          type: ActionType.GET_STATES_LIST_DONE,
          statesList: res.data,
        });
      })
      .catch(e => console.error(e));
  };
};

export const deleteDocument = (id: number) => {

  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    axios
      .delete(`/documents/${id}`)
      .then((res) => {
        dispatch({ type: ActionType.STOP_LOADING });
        dispatch({ type: ActionType.DELETE_DOCUMENT, id });
      });
  };
};

export const downloadTechSheetZip = (categoryName: string) => {
    return (dispatch: any) => {
        dispatch({
            type: ActionType.START_LOADING_ZIP,
            name: "Tech Sheets - " + categoryName,
            id: "techSheets" + categoryName,
            documentType: DownloadDocumentType.ZIP
        });

        axios.post("/seedtechsheetzip",
            {
                categoryName: categoryName,
                socketID
            }, {
                headers: { Accept: 'application/zip' },
            })
            .then((response) => {
                console.log('requested tech sheets for category ' + categoryName);
                GoogleAnalyticsEvents.downloadedTechSheets(categoryName);
            })
            .catch(error => console.error(error));
    };
};

export const downloadPdf = (document: IDocument,
  dividers: IDivider[], disclaimers: IDisclaimer[],
  userData: IUserData,
  isPrintDownload: boolean,
  useLegacy: boolean = false) => {
  return (dispatch: any) => {
    dispatch({
      type: ActionType.START_LOADING_PDF,
      name: document.name,
      id: document.id.toString(),
    });

    if (useLegacy) {
      axios.post("/convertToPDF",
      {
        document,
        socketID
      }, {
        headers: { Accept: 'application/pdf' },
      })
      .then((response) => {
        console.log('requested for document ' + document.id);
        GoogleAnalyticsEvents.downloadedPDF(document);
      })
      .catch(error => console.error(error));

      return;
    }

    fetchPDFStyles()
      .then((styles: string) => {
        if (isPrintDownload) {
          styles = styles.replace("</style>", ".product-hyperlink { visibility: hidden; } </style>");
        }
        const annotations = isPrintDownload ? [] : getDocumentLinkAnnotations(document);
        const documentAsString = renderDocumentToString(document, dividers, disclaimers, styles, isPrintDownload);

        createPDF({
          name: document.name,
          type: document.type,
          content: documentAsString,
          documentId: document.id,
          socketID: socketID,
          userID: userData.id,
          userEmail: userData.email,
          isPrintDownload: isPrintDownload,
          annotations: annotations,
        })
        .then((response) => {
          if (response.status === 200) {
              console.log('requested for document ' + document.id);
              GoogleAnalyticsEvents.downloadedPDF(document);
          }
        })
        .catch((error) => console.error(error));
      })
      .catch(error => console.error(error));
  };
};
export const downloadDivisionCostCsv = () => {
  return (dispatch: any) => {
    const now = new Date();
    const reportID = Math.round(now.getTime() / 1000);
      dispatch({
      type: ActionType.START_LOADING_DIV_COST_CSV,
      name: "Cost Report",
      id: reportID,
      documentType: DownloadDocumentType.CSV
    });

    axios.post("/createOrdersReport",
      {
        socketID,
        reportID
      }, {
        headers: { Accept: 'application/csv' },
      })
      .then((response) => {
        console.log('requested cost report');
        GoogleAnalyticsEvents.downloadedCSV();
      })
      .catch(error => console.error(error));
  };
};
export const downloadOrderAnalyticsCSV = (year: number) => {
  return (dispatch: any) => {
      const now = new Date();
      const reportID = Math.round(now.getTime() / 1000);
      dispatch({
          type: ActionType.START_LOADING_PRODUCT_ANALYTICS_CSV,
          name: "Order Analytics Report",
          id: reportID,
          documentType: DownloadDocumentType.CSV
      });

      axios.post("/createOrdersReport",
          {
              socketID,
              reportID,
              year
          }, {
              headers: { Accept: 'application/csv' },
          })
          .then((response) => {
              console.log('requested order analytics CSV');
              GoogleAnalyticsEvents.downloadedCSV();
          })
          .catch(error => console.error(error));
  };
};
export const downloadProductAnalyticsCSV = (year: number) => {
    return (dispatch: any) => {
        const now = new Date();
        const reportID = Math.round(now.getTime() / 1000);
        dispatch({
            type: ActionType.START_LOADING_PRODUCT_ANALYTICS_CSV,
            name: "Product Analytics Report",
            id: reportID,
            documentType: DownloadDocumentType.CSV
        });

        axios.post("/convertToProductAnalyticsCSV",
            {
                socketID,
                reportID,
                year
            }, {
                headers: { Accept: 'application/csv' },
            })
            .then((response) => {
                console.log('requested product analytics CSV');
                GoogleAnalyticsEvents.downloadedCSV();
            })
            .catch(error => console.error(error));
    };
};
export const validatePagesCountValue = (value: any) => {
  return (dispatch: any) => {
    dispatch({
      type: ActionType.VALIDATE_PAGES_COUNT_VALUE,
      value,
    });
  };
};
export const resetValidations = () => {
  return (dispatch: any) => {
    dispatch({
      type: ActionType.RESET_VALIDATIONS,
    });
  };
};
export const onPageOrSpreadSelect = (data: any) => {
  return (dispatch: any, getState: any) => {
    const { document } = getState();
    dispatch({
      type: ActionType.ON_PAGE_OR_SPREAD_SELECT,
      data,
      document,
    });
  };
};
export const onAddSinglePageOrSpread = () => {
  return (dispatch: any, getState: any) => {
    const { editor, document } = getState();
    dispatch({
      type: ActionType.CHANGE_DOCUMENT_PAGES_COUNT,
      pagesCount: document.pages.length + 2,
      docType: document.type,
      document,
      editor,
    });
    const updatedDocument = getState().document;
    dispatch({
      type: ActionType.ON_ADD_PAGE_OR_SPREAD,
      document: updatedDocument,
      editor,
    });
  };
};
export const onAddMultiPageOrSpread = () => {
  return (dispatch: any, getState: any) => {
    const { editor, document } = getState();
    dispatch({
      type: ActionType.CHANGE_DOCUMENT_PAGES_COUNT_MULTI_LAYOUT,
      pagesCount: document.pages.length + 2,
      docType: document.type,
      document,
      editor,
    });
    const updatedDocument = getState().document;
    dispatch({
      type: ActionType.ON_ADD_PAGE_OR_SPREAD,
      document: updatedDocument,
      editor,
    });
  };
};
export const onAddAgronomySpread = () => {
  return (dispatch: any, getState: any) => {
    const { editor, document } = getState();
    dispatch({
      type: ActionType.CHANGE_DOCUMENT_PAGES_COUNT_AGRONOMY_LAYOUT,
      pagesCount: document.pages.length + 2,
      docType: document.type,
      document,
      editor,
    });
    const updatedDocument = getState().document;
    dispatch({
      type: ActionType.ON_ADD_PAGE_OR_SPREAD,
      document: updatedDocument,
      editor,
    });
  };
};
export const onAddMixedSpread = () => {
  return (dispatch: any, getState: any) => {
    const { editor, document } = getState();
    dispatch({
      type: ActionType.CHANGE_DOCUMENT_PAGES_COUNT_MIXED_LAYOUT,
      pagesCount: document.pages.length + 2,
      docType: document.type,
      document,
      editor,
    });
    const updatedDocument = getState().document;
    dispatch({
      type: ActionType.ON_ADD_PAGE_OR_SPREAD,
      document: updatedDocument,
      editor,
    });
  };
};
export const onRemovePage = (pageId: number) => {
  return (dispatch: any, getState: any) => {
    const { editor } = getState();
    dispatch({
      type: ActionType.ON_REMOVE_PAGE,
      editor,
      docType: getState().document.type,
      allPages: getState().document.pages,
      pageId,
    });
    dispatch({
      type: ActionType.ON_REMOVE_PAGE_RESWITCH_EDITOR,
      editor,
      allPages: getState().document.pages,
      newSpreads: getState().document.spreads,
      pageId,
    });
  };
};
export const onRemoveSpread = (spreadId: number) => {
  return (dispatch: any, getState: any) => {
    const { editor } = getState();
    dispatch({
      type: ActionType.ON_REMOVE_SPREAD,
      docType: getState().document.type,
      allPages: getState().document.pages,
      allSpreads: getState().document.spreads,
      editor,
      spreadId,
    });
  };
};

export const changeZoom = (zoom: any) => {
  return (dispatch: any) => {
    dispatch({
      type: ActionType.CHANGE_ZOOM,
      payload: zoom,
    });
  };
};

export const moveThumbnail = (dragIndex: number, hoverIndex: number) => {
  return (dispatch: any, getState: any) => {
    const { editor, document } = getState();
    dispatch({
      dragIndex,
      hoverIndex,
      editor,
      document,
      type: ActionType.MOVE_THUMBNAIL,
    });
  };
};

export const onMovePlaceholders = (data: any) => {
  return (dispatch: any, getState: any) => {
    dispatch({
      type: ActionType.ON_MOVE_PLACEHOLDERS,
      data,
    });
  };
};

export const saveNavigationRoute = (path: string) => {
  return (dispatch: any) => {
    dispatch({
      type: ActionType.NAVIGATING,
      path: path,
    });
  };
};

// Brandings
export const createBranding = (brandingName: string, imageFormData: FormData, imageFormDataWhite: FormData) => {

  return (dispatch: any, getState: any) => {
    dispatch({ type: ActionType.START_LOADING });
    BrandingService
        .createBranding(brandingName, imageFormData, imageFormDataWhite)
        .then((brandingResponse: IBranding) => {
          GoogleAnalyticsEvents.createBranding(brandingResponse);
          dispatch({ type: ActionType.CREATE_BRANDING_DONE, branding: brandingResponse });
          dispatch({ type: ActionType.STOP_LOADING });
        })
        .catch(error => console.error(error));
  };
};

export const updateBranding = (brandingID: number, brandingName: string, imageFormData?: FormData, imageFormDataWhite?: FormData) => {
  return (dispatch: any, getState: any) => {
    dispatch({ type: ActionType.START_LOADING });
    BrandingService
        .updateBranding(brandingID, brandingName, imageFormData, imageFormDataWhite)
        .then((brandingResponse: IBranding) => {
          dispatch({ type: ActionType.UPDATE_BRANDING_DONE, branding: brandingResponse });
          dispatch({ type: ActionType.STOP_LOADING });
          GoogleAnalyticsEvents.editBranding(brandingResponse);
        })
        .catch(error => console.error(error));
  };
};

export const deleteBranding = (branding: IBranding) => {

  return (dispatch: any, getState: any) => {
    dispatch({ type: ActionType.START_LOADING });
    if (branding.id == undefined) {
        throw new Error("Invalid branding to delete - no id");
    }
    BrandingService
        .deleteBranding(branding.id)
        .then(() => {
          dispatch({ type: ActionType.DELETE_BRANDING_DONE, id: branding.id });
          dispatch({ type: ActionType.STOP_LOADING });
          GoogleAnalyticsEvents.deleteBranding(branding);
        })
        .catch(error => console.error(error));
  };
};

// Complimentary Logos
export const createComplimentaryLogo = (logoName: string, imageFormData: FormData) => {

  return (dispatch: any, getState: any) => {
    dispatch({ type: ActionType.START_LOADING });
    LogoService
        .createLogo(logoName, imageFormData)
        .then((logoResponse: ILogo) => {
          dispatch({ type: ActionType.CREATE_LOGO_DONE, logo: logoResponse });
          dispatch({ type: ActionType.STOP_LOADING });
          GoogleAnalyticsEvents.createComplimentaryLogo(logoResponse);
        })
        .catch(error => console.error(error));
  };
};

export const updateComplimentaryLogo = (logoID: number, logoName: string, imageFormData?: FormData) => {
  return (dispatch: any, getState: any) => {
    dispatch({ type: ActionType.START_LOADING });
    LogoService
        .updateLogo(logoID, logoName, imageFormData)
        .then((logoResponse: ILogo) => {
          dispatch({ type: ActionType.UPDATE_LOGO_DONE, logo: logoResponse });
          dispatch({ type: ActionType.STOP_LOADING });
            GoogleAnalyticsEvents.editComplimentaryLogo(logoResponse);
        })
        .catch(error => console.error(error));
  };
};

export const deleteComplimentaryLogo = (logo: ILogo) => {

  return (dispatch: any, getState: any) => {
    dispatch({ type: ActionType.START_LOADING });
    if (logo.id == undefined) {
        throw new Error("Invalid logo to delete - no id");
    }
    LogoService
        .deleteLogo(logo.id)
        .then(() => {
          dispatch({ type: ActionType.DELETE_LOGO_DONE, id: logo.id });
          dispatch({ type: ActionType.STOP_LOADING });
          GoogleAnalyticsEvents.deleteComplimentaryLogo(logo);
        })
        .catch(error => console.error(error));
  };
};

// Covers
export const createCover = (coverImageName: string, coverImageType: ProductLine, coverDocumentType: CoverDocumentType, formData: FormData) => {

  formData.set('coverImageName', coverImageName);
  formData.set('coverType', coverImageType.toString());
  formData.set('coverDocumentType', coverDocumentType.toString());
  return (dispatch: any, getState: any) => {
    dispatch({ type: ActionType.START_LOADING });
    CoverService
    .createCover(formData)
    .then((newCover: ICoverImage) => {
      dispatch({ type: ActionType.CREATE_COVER_IMAGE_DONE, newCoverImage: newCover})
      dispatch({ type: ActionType.STOP_LOADING});
      GoogleAnalyticsEvents.createFullscreenCover(newCover);
    })
    .catch(error => console.error(error));
  };
};

export const deleteCover = (cover: ICoverImage) => {

  return (dispatch: any, getState: any) => {
    dispatch({ type: ActionType.START_LOADING });
      if (cover.id == undefined) {
          throw new Error("Invalid cover to delete - no id");
      }
    CoverService
        .deleteCover(cover.id)
        .then(() => {
          dispatch({ type: ActionType.DELETE_COVER_IMAGE_DONE, id: cover.id });
          dispatch({ type: ActionType.STOP_LOADING });
            GoogleAnalyticsEvents.deleteFullscreenCover(cover);
        })
        .catch(error => console.error(error));
  };
};

export const deleteAllTechSheets = () => {
  
  return (dispatch: any, getState: any) => {
    dispatch({ type: ActionType.START_LOADING });

      TechSheetService
      .deleteAllTechSheets()
        .then(() => {
          dispatch({ type: ActionType.DELETE_ALL_TECH_SHEETS_DONE});
          dispatch({ type: ActionType.STOP_LOADING });
        })
        .catch(error => console.error(error));
  };
};

// Disclaimers
export const saveDisclaimer = (disclaimer: IDisclaimer) => {

  return (dispatch: any, getState: any) => {
    dispatch({ type: ActionType.START_LOADING });

    if (disclaimer.id)
    {
      DisclaimerService
        .updateDisclaimer(disclaimer)
        .then(() => {
          dispatch({ type: ActionType.UPDATE_DISCLAIMER_DONE, disclaimer });
          dispatch({ type: ActionType.STOP_LOADING });
          GoogleAnalyticsEvents.editDisclaimer(disclaimer);
        })
        .catch(error => console.error(error));
    } else {
      DisclaimerService
        .createDisclaimer(disclaimer)
        .then((disclaimerResponse) => {
          dispatch({ type: ActionType.CREATE_DISCLAIMER_DONE, disclaimer: disclaimerResponse });
          dispatch({ type: ActionType.STOP_LOADING });
          GoogleAnalyticsEvents.createDisclaimer(disclaimer);
        })
        .catch(error => console.error(error));
    }
  };
}

export const deleteDisclaimer = (disclaimer: IDisclaimer) => {

  return (dispatch: any, getState: any) => {
    dispatch({ type: ActionType.START_LOADING });
    if (disclaimer.id == undefined) {
        throw new Error("Invalid disclaimer to delete - no id");
    }
    DisclaimerService
        .deleteDisclaimer(disclaimer.id)
        .then(() => {
          dispatch({ type: ActionType.DELETE_DISCLAIMER_DONE, id: disclaimer.id });
          dispatch({ type: ActionType.STOP_LOADING });
          GoogleAnalyticsEvents.deleteDisclaimer(disclaimer);
        })
        .catch(error => console.error(error));
  };
}

// Taglines
export const getTaglines = () => {
  return (dispatch: any) => {
    axios
      .get('/taglines')
      .then(res => {
        dispatch({
          type: ActionType.GET_TAGLINES,
          taglines: res.data,
        })})
      .catch(e => console.error(e));
  };
};

export const saveTagline = (tagline: ITagline) => {
  return (dispatch: any, getState: any) => {
    dispatch({ type: ActionType.START_LOADING });

    if ((tagline.id) && (tagline.id >= 0))
    {
      TaglineService
        .updateTagline(tagline)
        .then(() => {
          dispatch({ type: ActionType.UPDATE_TAGLINE_DONE, tagline: tagline });
          dispatch({ type: ActionType.STOP_LOADING });
          GoogleAnalyticsEvents.editTagline(tagline);
        })
        .catch(error => console.error(error));
    } else {
      TaglineService
        .createTagline(tagline)
        .then((taglineResponse) => {
          dispatch({ type: ActionType.CREATE_TAGLINE_DONE, tagline: taglineResponse });
          dispatch({ type: ActionType.STOP_LOADING });
          GoogleAnalyticsEvents.createTagline(tagline);
        })
        .catch(error => console.error(error));
    }
  };
}

export const deleteTagline = (tagline: ITagline) => {
  return (dispatch: any, getState: any) => {
    dispatch({ type: ActionType.START_LOADING });
    if (tagline.id == undefined) {
        throw new Error("Invalid tagline to delete - no id");
    }
    TaglineService
        .deleteTagline(tagline.id)
        .then(() => {
          dispatch({ type: ActionType.DELETE_TAGLINE_DONE, id: tagline.id });
          dispatch({ type: ActionType.STOP_LOADING });
          GoogleAnalyticsEvents.deleteTagline(tagline);
        })
        .catch(error => console.error(error));
  };
}



// WEBPACK FOOTER //
// ./src/actions/actions.ts